import { router } from "@/shared/router"
import useValores from "./useValores"

export default function useNavigationV2(config) {

    const { assign, replace } = location
    const { path, reemplazar, modelo } = config || {}
    // const asignar = reemplazar ? replace : assign 

    const goTo = (fuente) => {
        const { asignarDesdeObj } = useValores(fuente)
        const query = asignarDesdeObj(modelo)

        path[0] === "/" ? router.push({ path, query, replace: reemplazar }) : assign(path)
    }

    return {
        goTo
    }
}